import { RouteName } from "constant/routeNames";
import FeaturePages from "layout/FeaturePages";
import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import VideoCreator from "./BecomeACreator/VideoCreator";
import SeeAllCreators from "./BecomeACreator/SeeAllCreators";
import SeeAllCreratorsVideos from "./BecomeACreator/SeeAllCreratorsVideos";
import WaringPage from "pages/WaringPage";

// only render creator profile for @-prefixed slugs
function CreatorSlugGuard({ children, layoutProps }: any) {
  const { slug } = useParams();
  if (!slug?.startsWith("@"))
    return <FeaturePages Content={WaringPage} {...layoutProps} title={""} />;
  return <>{children}</>;
}

function CreatorPage({ handleClick, isActive, setIsActive, anyPlayerActive }: any) {
  return (
    <div className={`${anyPlayerActive ? `mb-[140px]` : `mb-30`}`}>
      <Routes>
        <Route
          path={RouteName.VideoCreatorHome}
          element={
            <CreatorSlugGuard>
              <FeaturePages
                Content={VideoCreator}
                handleClick={handleClick}
                isActive={isActive}
                setIsActive={setIsActive}
                title={""}
              />
            </CreatorSlugGuard>
          }
        />
        <Route
          path={RouteName.SeeAllCreators}
          element={
            <FeaturePages
              Content={SeeAllCreators}
              handleClick={handleClick}
              isActive={isActive}
              setIsActive={setIsActive}
              title={""}
            />
          }
        />
        <Route
          path={RouteName.SeeAllCreatorsVideos}
          element={
            <FeaturePages
              Content={SeeAllCreratorsVideos}
              handleClick={handleClick}
              isActive={isActive}
              setIsActive={setIsActive}
              title={""}
            />
          }
        />
        {/* anything deeper like /foo/bar → 404 */}
        <Route path="*" element={<WaringPage />} />
      </Routes>
    </div>
  );
}

export default CreatorPage;